export default {
      id: "star-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite.1793797381340.svg#star-usage",
      toString: function () {
        return this.url;
      }
    }